// Accessing the sessionStorage property throws when a browser blocks site data.
export const readSession = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

// False when the value did not persist — it is then not a usable loop guard.
export const writeSession = (key: string, value: string): boolean => {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};
